import { useForm } from "react-hook-form";
import { AlertDialog } from "../common/AlertDailog";
import DynamicForm from "../common/DynamicForm";
import { zodResolver } from "@hookform/resolvers/zod";
import { centralLabSchema } from "../../config/schemas/centralLabSchema";
import { useCentralLab } from "../../hooks/useCentralLab";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../hooks/useSnackbar";
import FormFields from "./centralLabFields.json";
import { useCodelist } from "../../hooks/useCodelist";
import { z } from "zod";
import { setOpenAddCentralLabModal } from "../../store/slices/studiesSlice";
import { AppState, useAppDispatch, useAppSelector } from "../../store";

const AddCentralLab = (props: any) => {
  const { centralLabData, selectedStudy, getCentralLabDetail, isEdit } = props;
  const { showSuccess, handleError } = useSnackbar();
  const dispatch = useAppDispatch();
  const openAddCentralLabModal = useAppSelector(
    (state: AppState) => state.studiesSlice.openAddCentralLabModal
  );

  const [fieldsJson, setFieldsJson] = useState<any>(
    FormFields.centralLabFields
  );

  const {
    createCentralLab,
    updateCentralLab,
    createCentralLabError,
    createCentralLabIsError,
    createCentralLabIsSuccess,
    createCentralLabData,
    updateCentralLabIsSuccess,
    updateCentralLabData,
    updateCentralLabError,
    updateCentralLabIsError,
  } = useCentralLab();

  type FormValues = z.infer<typeof centralLabSchema>;

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    setFocus,
  } = useForm<FormValues>({
    resolver: zodResolver(centralLabSchema),
    defaultValues: centralLabData
      ? {
          ...centralLabData,
          country: {
            code_list_value: centralLabData?.country,
            code_list_value_code: centralLabData?.country_value_code,
          },
        }
      : {},
  });

  useEffect(() => {
    const firstError = Object.keys(errors)?.reduce((field: any, a) => {
      return (errors as any)[field] ? field : a;
    }, null);
    if (firstError) {
      setFocus(firstError);
    }
  }, [errors]);

  const { getCodelistData, codelistData } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: FormFields.CODES } });
  }, []);

  useEffect(() => {
    if (codelistData) {
      const temp = FormFields.centralLabFields.map((obj) => {
        if (obj.name == "country") {
          return {
            ...obj,
            options: codelistData?.find((item: any) => item.CNTRY?.length > 0)
              .CNTRY,
          };
        }
        return { ...obj };
      });
      setFieldsJson(temp);
    }
  }, [codelistData]);

  const handleCreateCentralLab = (data: any) => {
    const temp = {
      ...data,
      study_id: selectedStudy,
      country: data?.country?.code_list_value,
      country_code: FormFields?.CNTRY,
      country_value_code: data?.country?.code_list_value_code,
    };
    createCentralLab({ data: temp });
  };

  const handleUpdateCentralLab = (data: any) => {
    const temp = {
      ...data,
      study_id: selectedStudy,
      country: data?.country?.code_list_value,
      country_code: FormFields?.CNTRY,
      country_value_code: data?.country?.code_list_value_code,
    };
    updateCentralLab({ data: temp });
  };

  const onInvalid = (errors: any) => console.debug(errors);
  const submit = (data: any) => {
    isEdit ? handleUpdateCentralLab(data) : handleCreateCentralLab(data);
  };

  useEffect(() => {
    if (createCentralLabIsSuccess || updateCentralLabIsSuccess) {
      const successMsg = createCentralLabData ?? updateCentralLabData;
      getCentralLabDetail();
      const id =createCentralLabIsSuccess? 'central-lab-create-success':'central-lab-update-success'
      showSuccess(successMsg?.details,id);
      dispatch(setOpenAddCentralLabModal(false));
    }
  }, [createCentralLabIsSuccess, updateCentralLabIsSuccess]);

  useEffect(() => {
    if (createCentralLabIsError || updateCentralLabIsError) {
      const error: any = createCentralLabError ?? updateCentralLabError;
      handleError(error);
    }
  }, [createCentralLabIsError, updateCentralLabIsError]);

  return (
    <AlertDialog
      open={openAddCentralLabModal}
      title="Central Lab Details"
      handleClose={() => {
        dispatch(setOpenAddCentralLabModal(false));
      }}
      handleConfirm={handleSubmit(submit, onInvalid)}
      maxWidth="md"
    >
      <DynamicForm
        register={register}
        control={control}
        errors={errors}
        fieldsJson={fieldsJson}
      />
    </AlertDialog>
  );
};

export default AddCentralLab;
